<template>
  <!-- 电废三楼库存区 -->
  <div class="bd">
    <!-- src="https://www.thingjs.com/s/2e379ee6e7cf06dd9eaa19ad" -->
    <div class="main">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>库存：494吨</div>
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
        <div class="left-content slip_out_animation" style="height: 60%">
          <div class="type-title">
            <div>库存占比</div>
          </div>
          <div class="left-echarts-2" id="left-echarts-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {};
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
        this.createdCarEchartsRightBottom();
      });
    }, 300);
  },
  methods: {
    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-2");
      var myChart = echarts.init(leftEchartsTOP);
      var option;
      var allnumber = 0;
      option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return params.name + ":  " + params.data.value;
          },
        },
        graphic: [
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "43%",
            style: {
              text: `3147吨`,
              textAlign: "center",
              fill: "#FFF", //文字的颜色
              width: 30,
              height: 30,
              fontSize: 16,
              color: "#4d4f5c",
              fontFamily: "Microsoft YaHei",
            },
          },
          {
            //环形图中间添加文字
            type: "text", //通过不同top值可以设置上下显示
            left: "center",
            top: "53%",
            style: {
              text: `总计`,
              textAlign: "center",
              fill: "#FFF", //文字的颜色
              width: 30,
              height: 30,
              fontSize: 12,
              color: "#4d4f5c",
              fontFamily: "Microsoft YaHei",
            },
          },
        ],

        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          bottom: 'bottom',
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        series: [
          {
            name: "数量",
            type: "pie",
            radius: ["30%", "50%"],
            data: [
              { value: 1048, name: "ctr电视" },
              { value: 735, name: "液晶电视" },
              { value: 580, name: "冰箱类" },
              { value: 484, name: "洗衣机" },
              { value: 300, name: "电脑" },
            ],
            label: {
              color: "#FFF",
              formatter(param) {
                return param.percent + "%";
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          show: false,
        },
        grid: {
          top: 10,
          left: 80, // 调整这个属性
        },
        xAxis: {
          type: "value",
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: {
          axisLabel: {
            color: "#fff",
          },
          type: "category",
          data: [
            "ctr电视",
            "液晶电视",
            "冰箱类",
            "洗衣机类",
            "台式电脑类",
            "柜式空调类",
            "立式空调类别",
          ],
        },
        series: [
          {
            name: "",
            type: "bar",
            data: [23, 29, 104, 131, 30, 99, 60],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped lang="scss">
.main .left,
.main .right {
  width: 21.5vw;
  height: 75vh;
  background: rgba(17,47,107, 0.6);
  overflow: hidden;
}
.main .left {
  float: left;
  margin-left: 20px;
}
.main .right {
  float: right;
  margin-right: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  height: 40%;
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main .left .left-content .company-content {
  line-height: 40px;
  font-size: 18px;
  height: 51vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}

.main .right .right-content {
  padding: 20px;
  color: #fff;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 35vh;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px rgb(55, 51, 51) dotted;
}

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  height: 90%;
}
::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
</style>
  